import React, { useState, useEffect } from "react";
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { toast } from 'react-toastify';
import axios from 'axios';
import { config } from '../../utils/config';
import { Table, Tooltip } from "antd";
import { Link } from 'react-router-dom';
import { IoMdArrowBack } from "react-icons/io";
import { FaSearch, FaFolder, FaPlus, FaTags, FaEdit, FaTrash } from "react-icons/fa";
import styles from "./NewCategorylist.module.css";

const { apiEndpoint } = config;

export default function NewCategorylist({ item, editRedirect, deleteTax }) {
    const [listdata, setlistdata] = useState(item || []);
    const [initialData, setInitialData] = useState(item || []);
    const [parentCatName, setparentCatName] = useState("");
    const [downloadCSVModalOpen, setdownloadCSVModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [attributesState, setattributeState] = useState({
        data: [],
        attr_is_loading: false,
        submitting: false,
        parent_category_id: "",
        product_type_id: "",
        editing_attr_id: "",
        editing_attr_value: "",
        adding_new_attr: false,
        new_attr_value: ""
    });

    useEffect(() => {
        setlistdata(item || []);
        setInitialData(item || []);
    }, [item]);

    function handleBack() {
        setlistdata(initialData);
        setparentCatName("");
        setCurrentPage(1);
    }

    function handleShipementModalClose() {
        setdownloadCSVModalOpen(false);
        setattributeState({
            data: [],
            attr_is_loading: false,
            submitting: false,
            parent_category_id: "",
            product_type_id: "",
            editing_attr_id: "",
            editing_attr_value: "",
            adding_new_attr: false,
            new_attr_value: ""
        });
    }

    async function submitAttributesHandler() {
        const { new_attr_value } = attributesState;

        if (!new_attr_value || !new_attr_value.trim()) {
            toast.error("Attribute name is required!");
            return;
        }

        try {
            setattributeState((prev) => ({ ...prev, submitting: true }));

            const response = await axios({
                url: `${apiEndpoint}/createmandattr`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    parent_category_id: attributesState?.parent_category_id,
                    product_type_id: attributesState?.product_type_id,
                    mandatory_attribute: new_attr_value.trim()
                }
            });

            if (response?.data?.status === 200 || response?.data?.status === true) {
                toast.success("Attribute added successfully!");
                setattributeState((prev) => ({
                    ...prev,
                    submitting: false,
                    new_attr_value: '',
                    adding_new_attr: false
                }));
                listMandatoryAttr();
            } else {
                toast.error(response?.data?.message || "Something went wrong in payload!");
                setattributeState((prev) => ({ ...prev, submitting: false }));
            }
        } catch (err) {
            toast.error("Server error, please try later!");
            setattributeState((prev) => ({ ...prev, submitting: false }));
        }
    }

    async function updateAttributesHandler() {
        if (!attributesState?.editing_attr_id) {
            toast.error("Oops, something is wrong!");
            return;
        }
        if (!attributesState?.editing_attr_value?.trim()) {
            toast.error("Attribute name cannot be empty!");
            return;
        }

        try {
            const response = await axios({
                url: `${apiEndpoint}/updatemandateattr`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    id: attributesState?.editing_attr_id,
                    mandatory_attribute: attributesState?.editing_attr_value.trim(),
                    product_type_id: attributesState?.product_type_id
                }
            });

            if (response?.data?.status === 200 || response?.data?.status === true) {
                toast.success("Attribute updated successfully!");
                listMandatoryAttr();
            } else {
                toast.error(response?.data?.message || "Something went wrong in payload!");
                setattributeState((prev) => ({ ...prev, editing_attr_id: "" }));
            }
        } catch (err) {
            toast.error("Server error, please try later!");
        }
    }

    async function listMandatoryAttr() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/listmandattr`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    parent_category_id: attributesState?.parent_category_id,
                    product_type_id: attributesState?.product_type_id
                }
            });

            if (data?.status === 200 || data?.status === true) {
                setattributeState((prev) => ({
                    ...prev,
                    editing_attr_id: "",
                    data: data?.response || data?.data || []
                }));
            } else {
                toast.error("Something went wrong!");
            }
        } catch (error) {
            toast.error("Server error, please try later!");
        }
    }

    const openModalHandler = async (item) => {
        setdownloadCSVModalOpen(true);
        setattributeState((prev) => ({
            ...prev,
            attr_is_loading: true,
            parent_category_id: item?.parent_id,
            product_type_id: item?.id
        }));

        try {
            const { data } = await axios({
                url: `${apiEndpoint}/listmandattr`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    parent_category_id: item?.parent_id,
                    product_type_id: item?.id
                }
            });

            if (data?.status === 200 || data?.status === true) {
                setattributeState((prev) => ({
                    ...prev,
                    attr_is_loading: false,
                    parent_category_id: item?.parent_id,
                    product_type_id: item?.id,
                    data: data?.response || data?.data || []
                }));
            } else {
                toast.error("Something went wrong!");
                setattributeState((prev) => ({
                    ...prev,
                    attr_is_loading: false,
                    parent_category_id: item?.parent_id,
                    product_type_id: item?.id,
                    data: []
                }));
            }
        } catch (error) {
            toast.error("Server error, please try later!");
            setattributeState((prev) => ({
                ...prev,
                attr_is_loading: false,
                parent_category_id: item?.parent_id,
                product_type_id: item?.id
            }));
        }
    };

    async function deleteAttrHandler(id, name) {
        if (!window.confirm(`Are you sure you want to delete attribute "${name}"?`)) {
            return;
        }
        try {
            const response = await axios({
                url: `${apiEndpoint}/delmandateattr`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
                },
                data: {
                    id: id,
                    mandatory_attribute: name
                }
            });

            if (response?.data?.status === 200 || response?.data?.status === true) {
                toast.success("Attribute deleted!");
                listMandatoryAttr();
            } else {
                toast.error(response?.data?.message || "Something went wrong in payload!");
            }
        } catch (err) {
            toast.error("Server error, please try later!");
        }
    }

    const isParentList = listdata?.every(item => item.parent_id == 0 || item.parent_id == "0");

    // Filter listdata based on status
    const filteredData = (listdata || []).filter(item => {
        if (statusFilter === "active") return item?.status === true || item?.status === "true" || item?.status === 1;
        if (statusFilter === "inactive") return item?.status === false || item?.status === "false" || item?.status === 0;
        return true;
    });

    const columns = [
        {
            title: "Category Name",
            dataIndex: "cat_name",
            key: "cat_name",
            render: (_, record) => {
                const name = record.cat_name || record.name;
                return (
                    <div className={styles.categoryCell}>
                        <div className={styles.categoryIconBox}>
                            <FaFolder />
                        </div>
                        <div>
                            <span className={styles.categoryName}>{name}</span>
                        </div>
                    </div>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: "140px",
            render: (status) => {
                const isActive = status === true || status === "true" || status === 1;
                return isActive ? (
                    <span className={styles.activeStatusBadge}>
                        <span className={styles.statusDot} /> Active
                    </span>
                ) : (
                    <span className={styles.inactiveStatusBadge}>
                        <span className={styles.inactiveDot} /> Inactive
                    </span>
                );
            },
        },
        {
            title: "Product Type",
            key: "product_type",
            width: "200px",
            render: (_, item) => {
                const subCount = item?.subcategory?.length || 0;
                return subCount > 0 ? (
                    <Tooltip title="View Product Types / Subcategories">
                        <span
                            className={styles.subCatCountBadge}
                            onClick={() => (window.location.href = `/producttypelist`)}
                        >
                            <FaTags style={{ fontSize: "11px" }} />
                            Subcategories ({subCount})
                        </span>
                    </Tooltip>
                ) : (
                    <span style={{ color: "#94a3b8", fontSize: "13px", paddingLeft: "8px" }}>—</span>
                );
            },
        },
        {
            title: "Actions",
            key: "actions",
            width: "140px",
            render: (_, item) => (
                <div className={styles.actionGroup}>
                    {/* Edit Button */}
                    <Tooltip title="Edit Category">
                        <button
                            type="button"
                            className={`${styles.actionIconBtn} ${styles.editActionBtn}`}
                            onClick={() => editRedirect(item.id, parentCatName, isParentList)}
                        >
                            <EditNoteRoundedIcon fontSize="small" />
                        </button>
                    </Tooltip>

                    {/* Delete Button */}
                    <Tooltip title="Delete Category">
                        <button
                            type="button"
                            className={`${styles.actionIconBtn} ${styles.deleteActionBtn}`}
                            onClick={() => deleteTax(item.id, item.parent_id)}
                        >
                            <DeleteOutlineRoundedIcon fontSize="small" />
                        </button>
                    </Tooltip>

                    {/* Attributes Button */}
                    {!isParentList && (
                        <button
                            type="button"
                            className={styles.attributesBtn}
                            onClick={() => openModalHandler(item)}
                        >
                            Attributes
                        </button>
                    )}
                </div>
            ),
        },
    ];

    const dataSource = filteredData.map((item) => ({
        ...item,
        key: item.id || Math.random(),
    }));

    return (
        <div className={styles.container}>
            {/* Sub Category Header Banner */}
            {listdata.length > 0 && parentCatName !== "" && !isParentList && (
                <div className={styles.subCatBanner}>
                    <h3 className={styles.subCatTitle}>
                        <button type="button" className={styles.backBtn} onClick={handleBack} title="Go Back">
                            <IoMdArrowBack />
                        </button>
                        <span>Subcategories of <strong style={{ color: "#f97316" }}>{parentCatName}</strong></span>
                    </h3>
                    <Link to="/subcategory" className={styles.addSubCatBtn}>
                        <FaPlus style={{ fontSize: "11px" }} /> Add Subcategory
                    </Link>
                </div>
            )}

            {/* Controls Bar: Status Filter */}
            <div className={styles.controlsRow} style={{ justifyContent: "flex-end" }}>
                <select
                    className={styles.statusFilter}
                    value={statusFilter}
                    onChange={(e) => {
                        setStatusFilter(e.target.value);
                        setCurrentPage(1);
                    }}
                >
                    <option value="all">All Status</option>
                    <option value="active">Active Only</option>
                    <option value="inactive">Inactive Only</option>
                </select>
            </div>

            {/* Table Container */}
            <div className={styles.tableWrapper}>
                <Table
                    columns={columns}
                    dataSource={dataSource}
                    pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "20", "50"],
                        showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} categories`,
                        onChange: (page, size) => {
                            setCurrentPage(page);
                            setPageSize(size);
                        },
                        onShowSizeChange: (current, size) => {
                            setCurrentPage(1);
                            setPageSize(size);
                        }
                    }}
                    locale={{
                        emptyText: "No categories found"
                    }}
                />
            </div>

            {/* Mandatory Attributes Modal */}
            <Modal
                open={downloadCSVModalOpen}
                onClose={handleShipementModalClose}
                aria-labelledby="attributes-modal-title"
            >
                <Box className={styles.modalBox}>
                    <div className={styles.modalHeader}>
                        <h3 className={styles.modalTitle}>Mandatory Attributes</h3>
                        <button
                            type="button"
                            className={styles.modalCloseBtn}
                            onClick={handleShipementModalClose}
                        >
                            <CloseIcon fontSize="small" />
                        </button>
                    </div>

                    <div className={styles.modalBody}>
                        {/* Tab Switcher */}
                        <div className={styles.modalNavToggle}>
                            <button
                                type="button"
                                className={`${styles.tabBtn} ${!attributesState.adding_new_attr ? styles.tabBtnActive : ""}`}
                                onClick={() => {
                                    setattributeState((prev) => ({ ...prev, adding_new_attr: false }));
                                    listMandatoryAttr();
                                }}
                            >
                                Attribute List
                            </button>
                            <button
                                type="button"
                                className={`${styles.tabBtn} ${attributesState.adding_new_attr ? styles.tabBtnActive : ""}`}
                                onClick={() => setattributeState((prev) => ({ ...prev, adding_new_attr: true }))}
                            >
                                + Add New Attribute
                            </button>
                        </div>

                        {!attributesState?.adding_new_attr ? (
                            <div>
                                {attributesState?.data?.length > 0 && !attributesState.attr_is_loading ? (
                                    attributesState?.data?.map((attr) => (
                                        <div key={attr?.id} className={styles.attrListRow}>
                                            {attr.id === attributesState?.editing_attr_id ? (
                                                <input
                                                    type="text"
                                                    value={attributesState?.editing_attr_value}
                                                    className="form-control form-control-sm"
                                                    style={{ width: "65%" }}
                                                    onChange={(e) => setattributeState((prev) => ({ ...prev, editing_attr_value: e.target.value }))}
                                                />
                                            ) : (
                                                <span className={styles.attrName}>{attr?.mandatory_attribute}</span>
                                            )}

                                            {attr.id === attributesState?.editing_attr_id ? (
                                                <div style={{ display: "flex", gap: "6px" }}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm py-0 px-2 text-white font-weight-bold"
                                                        style={{ backgroundColor: "#f97316", borderColor: "#f97316" }}
                                                        onClick={updateAttributesHandler}
                                                    >
                                                        Save
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-secondary py-0 px-2"
                                                        onClick={() => setattributeState((prev) => ({ ...prev, editing_attr_id: "" }))}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            ) : (
                                                <div style={{ display: "flex", gap: "8px" }}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-light p-1"
                                                        style={{ color: "#f97316", border: "1px solid #ffedd5", backgroundColor: "#fff7ed" }}
                                                        onClick={() => setattributeState((prev) => ({
                                                            ...prev,
                                                            editing_attr_id: attr?.id,
                                                            editing_attr_value: attr?.mandatory_attribute
                                                        }))}
                                                        title="Edit"
                                                    >
                                                        <FaEdit />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-light p-1"
                                                        style={{ color: "#ef4444", border: "1px solid #e2e8f0" }}
                                                        onClick={() => deleteAttrHandler(attr?.id, attr?.mandatory_attribute)}
                                                        title="Delete"
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ))
                                ) : null}

                                {attributesState?.data?.length < 1 && !attributesState.attr_is_loading && (
                                    <p className="text-muted text-center my-4" style={{ fontSize: "13px" }}>
                                        No attributes found. Click <strong>+ Add New Attribute</strong> to create one.
                                    </p>
                                )}

                                {attributesState.attr_is_loading && (
                                    <p className="text-primary text-center my-4" style={{ fontSize: "13px" }}>
                                        Loading attributes...
                                    </p>
                                )}
                            </div>
                        ) : (
                            <div>
                                <div className="form-group mb-3">
                                    <label style={{ fontSize: "13px", fontWeight: 600, color: "#334155", marginBottom: "6px", display: "block" }}>
                                        Attribute Name <span style={{ color: "#ef4444" }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        placeholder="Enter Attribute Name (e.g. Size, Weight)"
                                        className="form-control"
                                        value={attributesState?.new_attr_value}
                                        onChange={(e) => setattributeState((prev) => ({ ...prev, new_attr_value: e.target.value }))}
                                    />
                                </div>
                                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                                    <button
                                        type="button"
                                        className="btn btn-light"
                                        onClick={() => setattributeState((prev) => ({ ...prev, adding_new_attr: false }))}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn text-white font-weight-bold"
                                        style={{ backgroundColor: "#f97316", borderColor: "#f97316" }}
                                        disabled={attributesState?.submitting}
                                        onClick={submitAttributesHandler}
                                    >
                                        {attributesState?.submitting ? "Saving..." : "Submit"}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </Box>
            </Modal>
        </div>
    );
}
